import { NavLink } from "react-router-dom";
import { FaBars, FaHome, FaCamera, FaMapMarkerAlt, FaUser, FaDatabase, FaPersonBooth } from "react-icons/fa";
import { MdSdCardAlert, MdAccountCircle } from "react-icons/md";
import { BiAnalyse, BiSearch } from "react-icons/bi";
import { AiFillControl, AiOutlineLogout, AiOutlineLineChart } from "react-icons/ai";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
const routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },
  // {
  //   path: "/UserManagement",
  //   name: "User Management",
  //   icon: <FaUser />,
  // },
  // {
  //   path: "/clientManagement",
  //   name: "Client Management",
  //   icon: <FaPersonBooth />,
  // },
  // {
  //   path: "/adminDashboard",
  //   name: "Admin Dashboard",
  //   icon: <FaPersonBooth />,
  // },


  {
    path: "/LogOut",
    name: "Log Out",
    icon: <AiOutlineLogout />,
  },
  // {
  //   path: "/ClientDashboard",
  //   name: "Client Dashboard",
  //   icon: <BiAnalyse />,
  // },

];

const SideBar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>
      <div className="main-container" >

              <div className="main-container" style={{ position:"fixed", top:0, bottom:0, left:0, overflowY:"auto" }}>

        <motion.div
          animate={{
            width: isOpen ? "260px" : "45px",

            transition: {
              duration: 0.5,
              type: "spring",
              damping: 10,
            },
          }}
          className={`sidebar `}
        >
          <div className="top_section">
            <AnimatePresence>
              {isOpen && (
                <motion.h1
                  variants={showAnimation}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="logo"
                >
                  <img src="/images/white-logo.png" alt="logo" />

                </motion.h1>
              )}
            </AnimatePresence>

            <div className="bars">
              <FaBars onClick={toggle} />
            </div>
          </div>
          {/* <div className="search">
            <div className="search_icon">
              <BiSearch />
            </div>
            <AnimatePresence>
              {isOpen && (
                <motion.input
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  variants={inputAnimation}
                  type="text"
                  placeholder="Search"
                />
              )}
            </AnimatePresence>
          </div> */}
          <section className="routes">
            {routes.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <NavLink
                  to={route.path}
                  key={index}
                  className="link"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })}
          </section>
        </motion.div>
              </div>
        <main style={{ marginLeft:"260px", flex:1, overflowY:"auto", background:"#f9fafb" }}
>{children}</main>
      </div>
    </>
  );
};

export default SideBar;
